/*eslint-disable*/
import { setCookie, getCookie } from '../utls/cookies.js'

export default registry => {
  const count = registry.querySelector('.js-registry-count')
  const needSID = registry.querySelectorAll('.need-sid')
  const registryId = registry.getAttribute('data-registry-id')
  const registryHelpToggle = registry.querySelector('.js-registry-help')

  registryHelpToggle.addEventListener('click', e => {
    e.preventDefault()
    registryHelpToggle.classList.toggle('open')
    const registryHelpBlock = registry.querySelector('.js-registry-help-block')
    registryHelpBlock.classList.toggle('open')
  })

  // Grab the item count from the cookie
  if (getCookie('gr_snowe_manage_number')) {
    count.innerHTML = getCookie('gr_snowe_manage_number')
  } else {
    setCookie('gr_snowe_manage_number', '0')
    count.innerHTML = 0
  }

  // Set the active navigation based on the current URL
  if (window.location.href.indexOf(`registry/${registryId}?`) > 0) {
    registry.querySelector('.js-registry-m').classList.add('active')
  } else if (window.location.href.indexOf(`collections/registry-builder`) > 0) {
    registry.querySelector('.js-registry-r').classList.add('active')
  } else if (window.location.href.indexOf(`registry/${registryId}/orders?`) > 0) {
    registry.querySelector('.js-registry-t').classList.add('active')
  } else if (window.location.href.indexOf(`registry/${registryId}/profile?`) > 0) {
    registry.querySelector('.js-registry-m').classList.add('active')
  }

  needSID.forEach(sid => {
    sid.addEventListener('click', e => {
      e.preventDefault()
      const sessionId = getCookie('giftreggie_session_cookie')
      if (sid.classList.contains('manage')) {
        registryId === '' || registryId === null
          ? $('.giftreggie-front').find('.select-registry-popup').parent().removeClass('transparent').find('span').text('Manage Your Registry')
          : window.location = `/apps/giftregistry/registry/${registryId}?sid=${sessionId}`
      } else if (sid.classList.contains('thank-you')) {
        registryId === '' || registryId === null
          ? $('.giftreggie-front').find('.select-registry-popup').parent().removeClass('hidden').removeClass('transparent').find('span').text('Thank You Manager')
          : window.location = `/apps/giftregistry/registry/${registryId}/orders?sid=${sessionId}`
      } else if (sid.classList.contains('edit-profile')) {
        registryId === '' || registryId === null
          ? $('.giftreggie-front').find('.select-registry-popup').parent().removeClass('hidden').removeClass('transparent').find('span').text('Account')
          : window.location = `/apps/giftregistry/registry/${registryId}/profile?sid=${sessionId}`
      } else if (sid.classList.contains('builder')) {
        registryId === '' || registryId === null
          ? $('.giftreggie-front').find('.select-registry-popup').parent().removeClass('hidden').removeClass('transparent').find('span').text('Registry Builder')
          : window.location = '/collections/registry-builder'
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/registry-admin.js